// src/App.js
import React, { useEffect, useState } from 'react';

import { AuthLoginForm } from './components/AuthLoginForm';
import { LayoutHeader } from './components/LayoutHeader';
import ChoferDashboard from './components/ChoferDashboard';
import TiendaDashboard from './components/TiendaDashboard';
import LavadorDashboard from './components/LavadorDashboard';
import MecanicoDashboard from './components/MecanicoDashboard';
import AdminDashboard from './components/AdminDashboard';

const STORAGE_KEY = 'user'; // clave de persistencia

function App() {
  const [user, setUser] = useState(null);

  // ✅ Restaurar sesión al montar la app
  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        // normalizar el role por si viene con mayúsculas
        if (parsed?.role) parsed.role = String(parsed.role).toLowerCase();
        setUser(parsed);
      }
    } catch (e) {
      console.warn('[App] No se pudo leer la sesión persistida:', e);
    }
  }, []);

  // ✅ Login: guardar en estado y localStorage
  const handleLogin = (loggedInUser) => {
    const normalized = {
      ...loggedInUser,
      role: String(loggedInUser?.role || '').toLowerCase(),
    };
    setUser(normalized);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
    } catch (e) {
      console.warn('[App] No se pudo persistir la sesión:', e);
    }
  };

  // ✅ Logout: limpiar localStorage y estado
  const handleLogout = () => {
    // opcional: avisar al backend para invalidar cookie/JWT
    fetch('/api/auth/logout', { method: 'POST', credentials: 'include' }).catch(() => {});
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      console.warn('[App] No se pudo eliminar la sesión persistida:', e);
    }
    setUser(null);
  };

  return (
    <div className="min-h-screen bg-gray-50 text-gray-900">
      {/* (Opcional) Paleta rápida de PROOMTB; mejor llevarla a tu CSS/Tailwind config */}
      <style>{`
        .bg-proomtb-dark { background-color: #000000; }   /* Negro */
        .bg-proomtb-light { background-color: #333333; }  /* Gris oscuro */
        .text-proomtb-dark { color: #000000; }
        .text-proomtb-light { color: #333333; }
        .focus\\:ring-proomtb-dark:focus { --tw-ring-color: #000000; }
      `}</style>

      {/* Si no hay sesión → mostrar login */}
      {!user ? (
        <div className="container mx-auto px-4 py-8">
          <AuthLoginForm onLogin={handleLogin} />
        </div>
      ) : (
        <>
          {/* Header con botón de salir */}
          <LayoutHeader user={user} onLogout={handleLogout} />

          {/* Contenido principal según rol */}
          <main className="container mx-auto px-4 py-8">
            {user.role === 'chofer' && <ChoferDashboard />}
            {user.role === 'tienda' && <TiendaDashboard />}
            {user.role === 'lavador' && <LavadorDashboard />}
            {user.role === 'mecanico' && <MecanicoDashboard />}
            {user.role === 'admin' && <AdminDashboard />}

            {/* Fallback por si llega otro rol */}
            {!['chofer', 'tienda', 'lavador', 'mecanico', 'admin'].includes(user.role) && (
              <div className="p-6 rounded-lg border bg-white">
                <h2 className="text-xl font-semibold">Bienvenido</h2>
                <p className="mt-2 text-sm text-gray-600">
                  Tu rol <strong>{String(user.role || 'desconocido')}</strong> no tiene un panel asignado.
                </p>
              </div>
            )}
          </main>
        </>
      )}
    </div>
  );
}

export default App;
